import Vue from 'vue'
import Router from 'vue-router'

import HomeRoutes from './home'
import TimelineRoutes from './timeline'
import SearchRoutes from './search'
import RegisterRoutes from './register'
import LoginRoutes from './login'
import ManageRoutes from './manage'
import AccountRoutes from './account'
import SellpointRoutes from './sellpoint'
import PurchaseRoutes from './purchase'
import DemosRoutes from './demos'
import CreateSellpointRoutes from './create'
import BuypointRoutes from './buypoint'
// import CartRoutes from './cart'
// import OrderRoutes from './order'
// import CheckoutRoutes from './checkout'
// import OrdersRoutes from './orders'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        HomeRoutes,
        TimelineRoutes,
        SearchRoutes,
        RegisterRoutes,
        LoginRoutes,
        ManageRoutes,
        PurchaseRoutes,
        DemosRoutes,
        AccountRoutes,
        CreateSellpointRoutes,
        BuypointRoutes,
        // CartRoutes,
        // OrderRoutes,
        // CheckoutRoutes,
        // OrdersRoutes,
        SellpointRoutes,
        // {path: '*', redirect: '/'} // 404
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js